import { render, staticRenderFns } from "./rootComment.vue?vue&type=template&id=44f56e24&scoped=true"
import script from "./rootComment.vue?vue&type=script&lang=ts"
export * from "./rootComment.vue?vue&type=script&lang=ts"
import style0 from "./rootComment.vue?vue&type=style&index=0&id=44f56e24&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f56e24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentConvert: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/ContentConvert/index.vue').default,ActionPopover: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/ActionPopover/index.vue').default})
